export default "__VITE_ASSET__HERIQaZV__"